import { selectAllExistingBuildingInfo } from "./selectExistingBuildingInfo";
import { selectExternalBarnCurrentStorage } from "./selectExternalBarnInfo";
import { selectInventoryResourceInfo } from "./selectInventoryInfo";
export var selectStorageInfo = function (state) {
    var storageFromBuildings = selectAllExistingBuildingInfo(state, true).reduce(function (acc, val) {
        return acc + (val.balancing.stage[Math.max(val.proto.stage - 1, 0)].storageCapacity || 0);
    }, 0);
    var storageFromExternalBarn = selectExternalBarnCurrentStorage(state);
    return storageFromBuildings + storageFromExternalBarn;
};
export var selectIsStorageFullForProduct = function (state, resourceId, resourceAmount) {
    var storageAmount = selectStorageInfo(state);
    var inventoryResourceInfo = selectInventoryResourceInfo(state, resourceId);
    var resourceSumAmount = inventoryResourceInfo.amount.add(resourceAmount);
    return resourceSumAmount.greaterThan(storageAmount);
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectStorageInfo.ts
// module id = 282
// module chunks = 3